import * as React from 'react';
var RadioGroupContext = React.createContext(null);
export var RadioGroupContextProvider = RadioGroupContext.Provider;
export default RadioGroupContext;


//////////////////
// WEBPACK FOOTER
// ./node_modules/_antd@4.1.3@antd/es/radio/context.js
// module id = 159
// module chunks = 0